import React from "react";
import { Table } from "react-bootstrap";

const TerminalSummaryTable = ({ summary }) => {
  if (!summary) {
    return null;
  }

  return (
    <div className="mt-3">
      <h5 className="text-center mb-3" style={{ fontSize: "1.1rem" }}>
        Summary/Overall Assessment
      </h5>

      <div>
        <Table striped bordered hover responsive size="sm">
          <thead className="table-primary">
            <tr>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Full Marks
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Gained Marks
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                In Percentage
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Grade
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Class Position
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Section Position
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Result Status
              </th>
              <th className="py-2" style={{ fontSize: "0.8rem" }}>
                Remark
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-bold py-1" style={{ fontSize: "0.75rem" }}>
                {summary.fullMarks}
              </td>
              <td className="fw-bold py-1" style={{ fontSize: "0.75rem" }}>
                {parseFloat(summary.gainedMarks).toFixed(2)}
              </td>
              <td className="fw-bold py-1" style={{ fontSize: "0.75rem" }}>
                {parseFloat(summary.percentage).toFixed(2)}%
              </td>
              <td className="py-1" style={{ fontSize: "0.75rem" }}>
                <span
                  className={`badge ${
                    summary.percentage >= 50 ? "bg-success" : "bg-danger"
                  }`}
                  style={{ fontSize: "0.65rem" }}
                >
                  {summary.grade}
                </span>
              </td>
              <td className="fw-bold py-1" style={{ fontSize: "0.75rem" }}>
                {summary.classPosition} ({summary.classTotalStudent})
              </td>
              <td className="fw-bold py-1" style={{ fontSize: "0.75rem" }}>
                {summary.sectionPosition} ({summary.sectionTotalStudent})
              </td>
              <td className="py-1" style={{ fontSize: "0.75rem" }}>
                <span
                  className={`badge ${
                    summary.resultStatus === "Passed"
                      ? "bg-success"
                      : "bg-danger"
                  }`}
                  style={{ fontSize: "0.65rem" }}
                >
                  {summary.resultStatus}
                </span>
              </td>
              <td className="fw-bold py-1" style={{ fontSize: "0.75rem" }}>
                {summary.remark}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TerminalSummaryTable;
